export const isLocal = import.meta.env.MODE === "development";
export const isStaging = window.origin.includes("staging");
export const isProd = !isLocal && !isStaging;

export const isDev = isLocal || isStaging;
